import React from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';

const ContactType = ({ label, value, handleUpdate }) => {
  return (
    <div className="personalDetails">
      <div className="fieldGroup">
        <div className="labelValueText">
          <span>
            <strong>{label}</strong>
          </span>
          <span>
            <em>{value}</em>
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={handleUpdate}
        className="button primary outline"
      >
        <Icon icon="pencil" />
        <span className="labelText">Update</span>
        <span className="sr-only"> contact details - {label}</span>
      </button>
    </div>
  );
};

export default ContactType;

ContactType.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleUpdate: PropTypes.func.isRequired
};
